import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Inject } from "@angular/core";

export interface FieldProperties {
  readonly: boolean;
  required: boolean;
}

@Component({
  selector: "app-dialog",
  templateUrl: "./dialog.component.html",
  styleUrls: ["./dialog.component.scss"],
})
export class DialogComponent implements OnInit {
  @Input() closable = false;
  @Input() visible: boolean = true;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editEvent = new EventEmitter<any>();

  @Output() fieldPropertiesChanged: EventEmitter<FieldProperties> =
    new EventEmitter<FieldProperties>();

  detailForm: FormGroup;
  inputField: any[] = [];

  selectedFields: string[] = [];
  readonly: boolean;
  required: boolean;

  constructor(
    private dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  fieldProperties: FieldProperties = {
    readonly: false,
    required: false,
  };
  ngOnInit() {
    if (this.data && this.data.fieldProperties) {
      this.fieldProperties = { ...this.data.fieldProperties };
    }

    console.log("Data", this.data);
  }

  ok() {
    // Only emit the fieldProperties if the dialog is opened
    if (this.visible) {
      this.dialogRef.close(this.fieldProperties);
      this.fieldPropertiesChanged.emit(this.fieldProperties);
      console.log("Result *** ", this.fieldProperties);
    } else {
      console.log("Dialog is not opened, no changes to emit.");
    }
  }

  close() {
    this.dialogRef.close();
  }
}
